import { render } from "./OrderStatusSmsTemplatesCard.vue?vue&type=template&id=0e8db5ac"
import script from "./OrderStatusSmsTemplatesCard.vue?vue&type=script&lang=js"
export * from "./OrderStatusSmsTemplatesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__